/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest'
import type { OpenAPIConfig } from './core/OpenAPI'
import { AxiosHttpRequest } from './core/AxiosHttpRequest'
import { AuthService } from './services/AuthService'
import { Oauth2Service } from './services/Oauth2Service'
import { SystemService } from './services/SystemService'
import { UserService } from './services/UserService'
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest
export class MobileAuthApiClient {
  public readonly auth: AuthService
  public readonly oauth2: Oauth2Service
  public readonly system: SystemService
  public readonly user: UserService
  public readonly request: BaseHttpRequest
  constructor(
    config?: Partial<OpenAPIConfig>,
    HttpRequest: HttpRequestConstructor = AxiosHttpRequest
  ) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? '',
      VERSION: config?.VERSION ?? '0.1',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH
    })
    this.auth = new AuthService(this.request)
    this.oauth2 = new Oauth2Service(this.request)
    this.system = new SystemService(this.request)
    this.user = new UserService(this.request)
  }
}
